import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'wage_grade_level_most_represented_in_the_fac_average_monthly_ba_1'

export const dataPointDefinition = {
  retracedId: 'wage_grade_level_most_represented_in_the_fac_average_monthly_ba_1',
  name: 'Wage grade / level most represented in the facility: Average monthly basic wage - female',
  description:
    'In the wage grade / level most represented in the facility, what is the average monthly basic wage for female workers?\r\r\n\r\r\n"Wage grade / level most represented in the facility" means the wage grade/ level that most of the workers in the facility belong to / the wage group in which the majority of the workers fall into.\r\r\n\r\r\n"Average monthly" means the average calculated by month taking a period of 12 months into account. \r\r\n\r\r\n"Basic wage" means the rate of pay for a standard work period excluding additional payments like bonuses and overtime.',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wage-50',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 8150,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
